<template lang="pug">
  div
    .common-modal(v-if="!completed" :class="{ open: sending }")
      a.common-modal-close(@click="close")
        | 閉じる
      .common-modal-title
        | 現在の条件で通知設定します
      .common-modal-main
        .common-modal-main-inner
          .box-modal-notification-setting
            p
              ErrorMessage(:errors="errors" name="system")
            p
              | 最大50件、通知設定を保存することができます。
            p
              label.radio
                input(type='radio' v-model="isNew" v-bind:value="true")
                span 新規
              br
              label.radio
                input(type='radio' v-model="isNew" v-bind:value="false" :disabled="savedList.length == 0")
                span 既存の条件に上書き保存
              br
              template(v-if="!isNew")
                select(v-model="updateId")
                  option(v-for="option in savedList" :value="option.id") {{ option.name }}
            ul
              li
                span
                  | 通知名
                input(type="text" v-model="name" placeholder="例）リクナビネクスト／上場企業", :disabled="locked")
              li
                span
                  | 通知曜日
                label.checkbox
                  input(type='checkbox' v-model="monday" true-value="true" false-value="false")
                  span 月
                label.checkbox
                  input(type='checkbox' v-model="tuesday" true-value="true" false-value="false")
                  span 火
                label.checkbox
                  input(type='checkbox' v-model="wednesday" true-value="true" false-value="false")
                  span 水
                label.checkbox
                  input(type='checkbox' v-model="thursday" true-value="true" false-value="false")
                  span 木
                label.checkbox
                  input(type='checkbox' v-model="friday" true-value="true" false-value="false")
                  span 金
                label.checkbox
                  input(type='checkbox' v-model="saturday" true-value="true" false-value="false")
                  span 土
                label.checkbox
                  input(type='checkbox' v-model="sunday" true-value="true" false-value="false")
                  span 日
              li
                span
                  | 通知時間
                select(v-model="hour")
                  option(v-for="option in hourItems" :value="option") {{ option }}
                | ：
                select(v-model="minutes")
                  option(v-for="option in minutesItems" :value="option") {{ option }}
              li
                span 新着件数
                input.lower-limit-count-input(
                  type="text"
                  v-model="lowerLimitCount"
                  placeholder="半角数字のみ")
                | 件以上の求人が集まったとき<br />
                | ※10,000件まで設定可能です
          p.common-modal-button
            input.button-main(type="button", value="保存する" @click="saveJobNotificationSetting")
    .common-modal(v-else :class="{ open: sending }")
      a.common-modal-close(@click="close")
        | 閉じる
      .common-modal-title
        | 通知設定を追加しました
      .common-modal-main
        .common-modal-main-inner
          p
            | 条件を通知設定管理に追加しました。
            br
            | 追加された通知設定は通知設定管理からご確認いただけます。
          p.common-modal-button
            router-link(:to="{ name: 'JobNotificationSettings' }",
                        class="button-main" @click.native="close")
              |  通知設定管理を確認する
    .modal-cover(@click="close")

</template>

<script>
  import { mapState, mapGetters } from 'vuex'
  import ClickOutside from 'vue-click-outside'
  import ErrorMessage from './ErrorMessage'

  const maxHour = 24
  const hourRange = [...Array(maxHour).keys()]

  export default {
    directives: { ClickOutside },
    data () {
      return {
        name: '',
        completed: false,
        isNew: true,
        updateId: null,
        minutes: '',
        hour: '',
        monday: false,
        tuesday: false,
        wednesday: false,
        thursday: false,
        friday: false,
        saturday: false,
        sunday: false,
        lowerLimitCount: '',
        hourItems: hourRange,
        minutesItems: ['00', '15', '30', '45'],
        modalOpen: false,
      }
    },
    components: { ErrorMessage },
    mounted () {
      this.popupItem = this.$el
    },
    computed: {
      ...mapState({
        errors: state => state.jobNotificationSetting.errors,
      }),
      ...mapGetters({
        locked: 'common/isGlobalLocked',
        sending: 'jobNotificationSetting/sending',
        savedList: 'jobNotificationSetting/list',
        condition: 'jobNotificationSetting/condition',
      }),
    },
    created () {
      this.$store.commit('jobNotificationSetting/hideJobNotificationSettingModal')
    },
    watch: {
      $route () {
        this.$store.commit('jobNotificationSetting/hideJobNotificationSettingModal')
      },
    },
    methods: {
      close () {
        this.$store.commit('jobNotificationSetting/hideJobNotificationSettingModal')
        this.$store.commit('jobNotificationSetting/errors', [])
        this.completed = false
        this.name = ''
        this.isNew = true
        this.minutes = ''
        this.hour = ''
        this.monday = ''
        this.tuesday = ''
        this.wednesday = ''
        this.thursday = ''
        this.friday = ''
        this.saturday = ''
        this.sunday = ''
        this.lowerLimitCount = ''
      },
      async saveJobNotificationSetting () {
        const name = this.name
        const condition = this.condition
        const id = this.isNew ? null : this.updateId
        const minutes = this.minutes
        const hour = this.hour
        const lowerLimitCount = this.lowerLimitCount
        const monday = this.monday
        const tuesday = this.tuesday
        const wednesday = this.wednesday
        const thursday = this.thursday
        const friday = this.friday
        const saturday = this.saturday
        const sunday = this.sunday

        this.$store.commit('common/lockGlobal')
        try {
          await this.$store.dispatch('jobNotificationSetting/send', { id,
                                                                      name,
                                                                      condition,
                                                                      monday,
                                                                      tuesday,
                                                                      wednesday,
                                                                      thursday,
                                                                      friday,
                                                                      saturday,
                                                                      sunday,
                                                                      hour,
                                                                      minutes,
                                                                      lowerLimitCount,
                                                                     })
          this.completed = true
          this.name = ''
        } finally {
          this.$store.commit('common/unlockGlobal')
        }
      },
    },
  }
</script>



// WEBPACK FOOTER //
// src/components/parts/JobNotificationSettingModal.vue